<template>
  <div v-show="!!creative" class="overlay" @click="clear">
    <transition name="fade" appear>
      <div v-if="vimeoId">
        <iframe :src="`https://player.vimeo.com/video/${vimeoId}?autoplay=1&title=0&byline=0&portrait=0`"
          :width="size.width"
          :height="size.height"
          frameborder="0"
          webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  computed: {
    creative() {
      return EventBus.creative;
    },
    vimeoId() {
      if (!this.creative) { return null; }
      const vimeoURL = this.creative.vimeoURL;
      /* eslint-disable */
      const vimeoRe = /https?:\/\/(?:(?:www|(?:player))\.)?vimeo(?:pro)?\.com\/(?!(?:channels|album)\/[^/?#]+\/?(?:$|[?#])|[^/]+\/review\/|ondemand\/)(?:.*?\/)?(?:(?:play_redirect_hls|moogaloop\.swf)\?clip_id=)?(?:videos?\/)?([0-9]+)(?:\/[\da-f]+)?\/?(?:[?&].*)?(?:[#].*)?$/g
      /* eslint-enable */
      const matches = vimeoRe.exec(vimeoURL);
      if (!matches) { return null; }
      return matches[1];
    },
    size() {
      const isDesktop = this.creative.platform === 'Desktop';
      const ratio = isDesktop ? 9 / 16 : 568 / 320;
      const width1 = Math.floor(window.innerWidth * 0.8);
      const height1 = Math.floor(width1 * ratio);
      const height2 = Math.floor(window.innerHeight * 0.8);
      const width2 = Math.floor(height2 / ratio);

      if (width2 < window.innerWidth) {
        return {
          width: width2,
          height: height2,
        };
      }
      return {
        width: width1,
        height: height1,
      };
    },
  },
  methods: {
    clear() {
      EventBus.creative = null;
      const query = Object.assign({}, this.$route.query);
      delete query.id;
      this.$router.replace({ path: '/', query });
    },
  },
};
</script>

<style scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fade-enter-active {
    transition: opacity .5s ease;
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-to {
    opacity: 1;
  }

  .fadein {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// Overlay.vue?08a7bdeb